import { DropdownButtonSize } from "./DropdownButton";

import styles from "./DropdownButton.module.scss";

interface IDropdownItemProps {
    /**
     * The size of the dropdown item
     */
    size?: DropdownButtonSize;

    /**
     * the id of the dropdown item.
     */
    id?: string;

    /**
     * The label of the item.
     */
    label: string;

    /**
     * Whether to disable the button click event.
     */
    disabled?: boolean;

    /**
      * A callback to invoke when the item is clicked.
      */
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

    /**
     * The icon of the item.
     */
    iconButton?: JSX.Element;
}

/**
 * An item inside the dropdown container.
 * @param {IDropdownItemProps} param The props used to render the dropdown item.
 * @returns The rendered component.
 */
function DropdownItem({
    size,
    id,
    label,
    disabled,
    onClick,
    iconButton
}: Readonly<IDropdownItemProps>): JSX.Element {
    return (
        <button
            className={`${styles.dropdownItem} ${styles[size]}`}
            onClick={e => onClick(e)}
            disabled={disabled}
            id={id}
            title={label}
        >
            {label}
            {iconButton}
        </button>
    );
}

export { DropdownItem, IDropdownItemProps };
